import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Button from '../Button/Button';

import withIdContext from '../../decorators/withIdContext';

export const ButtonTooltip = ({
  btStyle,
  disabled,
  label,
  onClick,
  type,
  disabledReason,
  disabledReasonPlacement,
  isLoading,
}) => {
  if (disabledReason && disabled) {
    return (
      <OverlayTrigger
        placement={disabledReasonPlacement}
        overlay={<Tooltip id={label}>{disabledReason}</Tooltip>}
      >
        <div className={`btn btn-${btStyle}`} disabled={disabled}>
          {label}
        </div>
      </OverlayTrigger>
    );
  }
  return (
    <Button
      bStyle={btStyle}
      type={type}
      disabled={disabled}
      onClick={onClick}
      isLoading={isLoading}
    >
      {label}
    </Button>
  );
};

ButtonTooltip.propTypes = {
  /** Button Style */
  btStyle: PropTypes.oneOf(['link', 'primary', 'success']),
  /** Button label */
  label: PropTypes.string,
  /** Loading spinner and disabling button */
  isLoading: PropTypes.bool,
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
  /** The tooltip describing why the action is disabled */
  disabledReason: PropTypes.string,
  /** Where the tooltip should pop up relative to the action */
  disabledReasonPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};

ButtonTooltip.defaultProps = {
  btStyle: 'link',
  label: '',
  type: 'button',
  disabled: false,
  isLoading: false,
  disabledReason: null,
  disabledReasonPlacement: 'top',
};

export default withIdContext()(ButtonTooltip);
